// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB4RIOUGiUcy4Ayg_IDEvduwIBY4EJbMU0",
  authDomain: "azhar-de6d7.firebaseapp.com",
  databaseURL: "https://azhar-de6d7-default-rtdb.firebaseio.com",
  projectId: "azhar-de6d7",
  storageBucket: "azhar-de6d7.firebasestorage.app",
  messagingSenderId: "1064730833016",
  appId: "1:1064730833016:web:30ab6da13ad6082943bd8d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
